<script>
	import { setElement } from './map'
	import { onMount } from 'svelte'

	let element
	
	onMount(() => {
		setElement(element)
	})
</script>

<div bind:this={element} class="map"></div>

<style>
	.map {
		width: 100%;
		height: 100%;
		text-align: left;
		z-index: 5;
		font-size: 8pt;
	}
</style>